import { AssessmentTestContextType } from '..';
import { closeOpenStepIntervals, queueForSync } from '../helpers';

export type FinishTestActionType = {
  type: 'FINISH_TEST';
  timestamp: Date;
};

export function finishTestReducer(
  state: AssessmentTestContextType,
  action: FinishTestActionType
): AssessmentTestContextType {
  if (state.screen.type !== 'STEP') {
    throw new Error('FINISH_TEST can only be called when in step screen');
  }
  const lastStepIndex = state.steps.length - 1;
  if (state.screen.stepIndex !== lastStepIndex) {
    throw new Error('FINISH_TEST can only be called when on the last step');
  }
  const currentStep = state.steps[lastStepIndex];
  return {
    ...state,
    ...queueForSync(state),
    screen: { type: 'OUTRO' },
    finishedAt: action.timestamp,
    finishReason: 'COMPLETED',
    steps: state.steps.map((s) =>
      s.id === currentStep.id
        ? closeOpenStepIntervals({ step: s, timestamp: action.timestamp })
        : s
    ),
  };
}
